/**
 * Better Auth browser client.
 *
 * This file replaces the old `lib/auth.ts` + `lib/session.ts` pair, and with them
 * a whole category of client-side work that no longer exists:
 *
 *   - No token storage. The session is an HTTP-only cookie, so the browser holds
 *     nothing readable and there is no `cwy_token` / `cwy_claims` /
 *     `cwy_refresh_token` in localStorage.
 *   - No client-side JWT decoding. The old client decoded the access token
 *     unverified to read the role and board/grade for display.
 *   - No refresh plumbing. There is no 15-minute access token to exchange, so the
 *     single-flight refresh dedupe and the 401→refresh→retry interceptor are gone.
 *
 * Identity beyond the session (role, board, grade, school) comes from
 * `GET /api/v1/me`, which reads the database rather than a stale token claim.
 */
import { createAuthClient } from 'better-auth/react';
import { apiOrigin } from '@/lib/apiOrigin';

export const authClient = createAuthClient({
  // The session cookie is HTTP-only and crosses the web/API subdomains through
  // credentialed CORS. `apiOrigin` falls back to the current origin for local
  // proxy-based development when VITE_API_URL is absent.
  baseURL: apiOrigin,
  basePath: '/api/auth',
});

// The typed lifecycle wrappers live in `lib/session.ts`; `landingPathFor` lives
// in `lib/auth.ts` alongside the other synchronous account readers.
